<template>
  <component :is="viewId" :params="params"></component>
</template>

<script>
  import systemSet_org_user from '../views/systemSet/org/user';
  import systemSet_org_role from '../views/systemSet/org/role';
  import systemSet_org_roleList from '../views/systemSet/org/roleList';
  import systemSet_org_group from '../views/systemSet/org/group';
  import systemSet_org_InvalidUser from '../views/systemSet/org/InvalidUser';
  import systemSet_org_groups from '../views/systemSet/org/groups';
  import systemSet_org_outerOrg from '../views/systemSet/org/commonOuterOrg';
  import systemSet_org_dataDic from '../views/systemSet/org/dataDic';
  import systemSet_org_dataDic_edit from '../views/systemSet/org/dataDicEdit';
  import systemSet_org_full_auth  from '../views/systemSet/org/fullAuth';

  import systemSet_script from '../views/systemSet/set/script';
  import systemSet_flow from '../views/systemSet/set/flow';
  import systemSet_set from '../views/systemSet/set/set';
  import systemSet_worktime from '../views/systemSet/set/worktime';
  import systemSet_multilingual from '../views/systemSet/set/multilingual';
  import systemSet_recycleBin from '../views/systemSet/set/recycleBin';
  import clear_data_or_exp_impl from '../views/maintain/clearDataOrExpImpl';
  import systemSet_flowInterfering from '../views/systemSet/set/flowInterfering';

  import systemSet_navigator from '../views/appModule/navigator_tree/index'

  import systemSet_log_loginLog from '../views/systemSet/log/loginLog'
  import systemSet_log_personalLog from '../views/systemSet/log/personalLog'
  import systemSet_log_operationLog from '../views/systemSet/log/operationLog'
  import systemSet_log_flowLog from '../views/systemSet/log/flowLog'
  import systemSet_log_flowTransLog from '../views/systemSet/log/flowTransLog'
  import systemSet_log_accessLog from '../views/systemSet/log/accessLog'

  import systemSet_file_manager from '../views/appModule/file_manager'

    export default {
        name: "MwInnerView",
        components:{
          systemSet_org_user,
          systemSet_org_role,
          systemSet_org_roleList,
          systemSet_org_group,
          systemSet_org_InvalidUser,
          systemSet_org_groups,
          systemSet_org_outerOrg,
          systemSet_org_dataDic,
          systemSet_org_dataDic_edit,
          systemSet_org_full_auth,
          systemSet_script,
          systemSet_flow,
          systemSet_set,
          systemSet_worktime,
          systemSet_multilingual,
          systemSet_flowInterfering,
          clear_data_or_exp_impl,
          systemSet_recycleBin,
          systemSet_navigator,
          systemSet_log_loginLog,
          systemSet_log_personalLog,
          systemSet_log_operationLog,
          systemSet_log_flowLog,
          systemSet_log_flowTransLog,
          systemSet_log_accessLog,
          systemSet_file_manager
        },
        props:{
          viewId:String,
          params:Object
        },

         data(){
           return {
             comp:{}
           }
        },
      mounted() {
        let me=this;
        //说明，用code split的时候，发现无法把vue组件里面的style加载进来。先不用code split了还是直接import。
        /*import(/!* webpackChunkName: "contribInnerView" *!/ './exportInnerView.js').then(({default: comps}) => {
          me.comp=comps[me.viewId]
        });*/
      },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/index/components/MwInnerView.vue